import { render } from "./DjiOutBoundOrderView.vue?vue&type=template&id=7708bda6&scoped=true"
import script from "./DjiOutBoundOrderView.vue?vue&type=script&lang=js"
export * from "./DjiOutBoundOrderView.vue?vue&type=script&lang=js"

import "./DjiOutBoundOrderView.vue?vue&type=style&index=0&id=7708bda6&scoped=true&lang=less"

import exportComponent from "E:\\work\\苏州卓盛\\捷博独立发货\\jb-dji-wms-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7708bda6"]])

export default __exports__